<template>
	<!--div-->
		<form ref="uploadForm" class="box" :style="style" method="post" action="" enctype="multipart/form-data">
						  
			 <div class="upload-btn-wrapper">
			  <button class="btn">{{typeof this.buttonText === 'undefined' ? translater.__('Upload files')
				  : translater.__(this.buttonText)}}
			  	<input type="file" id="file" name="files[]" multiple />
			  </button>
			  <div style="clear: both;"></div>
			</div>
			<div style="clear: both">{{typeof this.instructionText === 'undefined' ? translater.__('You can upload multiple files by dropping them here') : translater.__(this.instructionText)}}</div>

			<v-btn @click="cancelIsBeingReplaced(edit)" color="primary"  v-if="typeof edit !== 'undefined'" small>{{translater.__('Cancel')}}</v-btn>






			<!-- starts -->



			<!--div v-if="filesToUpload.length > 0 && uploadAudioTaskAnswerImage !== true" id="progress-list"-->
			<div v-if="filesToUpload.length > 0 && this.showUploadList !== false" id="progress-list">
			<v-layout row>
				<v-flex xs12 sm6 offset-sm3>
      				<v-card>
      					
      					<v-list two-line class="uploaded-list">
      						<template v-for="(ftu, i) in filesToUpload" >
      							<!--v-subheader>
      								{{ftu.name}}
      							</v-subheader-->
      							<v-list-tile :key="i">
      								<v-list-tile-content>
      									<v-list-tile-title>{{ftu.name}}</v-list-tile-title>
      									<v-list-tile-title v-if="typeof ftu.error !== 'undefined'"><small>{{ftu.error.text}} </small></v-list-tile-title>
      									<!--v-list-tile-title v-if="typeof ftu.progress !== 'undefined'">{{ftu.progress}}% </v-list-tile-title-->
      									<v-progress-linear v-if="typeof ftu.progress !== 'undefined'" v-model="ftu.progress"></v-progress-linear>
      								</v-list-tile-content>
      								<v-list-tile-action v-if="ftu.error && ftu.error.type === 'duplicate'">
						                <v-list-tile-action-text></v-list-tile-action-text>
						                <v-icon
						                 @click="replace(ftu)"
						                >
						                  check_circle
						                </v-icon>
						                 <v-icon
						                 @click="cancel(ftu)"
						                >
						                  cancel
						                </v-icon>

						                
						              </v-list-tile-action>

						              <v-list-tile-action v-if="ftu.error && (ftu.error.type === 'filetype' || ftu.error.type === 'fileexists' )">
						                <v-list-tile-action-text></v-list-tile-action-text>
						                
						                 <v-icon
						                 @click="cancel(ftu)"
						                >
						                  cancel
						                </v-icon>

						                
						              </v-list-tile-action>

						              <v-list-tile-action v-if="ftu.uploaded">
						                <v-list-tile-action-text></v-list-tile-action-text>
						                <v-icon
						                 @click="remove(ftu)"
						                >
						                  delete
						                </v-icon>

						                
						              </v-list-tile-action>
      							</v-list-tile>
      						</template>
      					</v-list>
      					
      				</v-card>

      			</v-flex>
			</v-layout>
		</div>

		<!--div v-if="uploadAudioTaskAnswerImage === true">
			<div class="error-text" v-if="audioTaskAnswerImagesToUpload[this.audioFile] && audioTaskAnswerImagesToUpload[this.audioFile].error">
				{{audioTaskAnswerImagesToUpload[this.audioFile].error.text}}
			</div-->
			<!--div v-else>elsessa</div-->
		<!--/div-->



			<!--ends -->
		  
		</form>
		
	<!--/div-->
	
</template>


<style>
	
	.error-text
	{
		color: red;
	}

	small{
		color: red;
	}

	.v-card{
		margin-bottom:2em;
	}

	.uploaded-list{
		margin-top:2em;
	}

	

	.upload-btn-wrapper {
	  position: relative;
	  overflow: hidden;
	  display: inline-block;
	  margin-top:150px;

	}

	.btn {
	  border: 2px solid gray;
	  color: gray;
	  background-color: white;
	  padding: 8px 20px;
	  border-radius: 8px;
	  font-size: 20px;
	  font-weight: bold;
	  left:0;
	 

	}

	.upload-btn-wrapper input[type=file] {
	  font-size: 100px;
	  position: absolute;
	  left: 50%;
	  top: 0;
	  opacity: 0;
	  cursor: pointer;
	}


	.box {
	  background-color: white;
	  outline: 2px dashed black;
	  outline-offset: -10px;
	  min-height: 300px;
	}

	.box__dragndrop {
 	 	display: inline;
	}

</style>


<script>

	import axios from 'axios';
	import {APIURL} from '../../../constants'
	
	export default {
		name: 'Upload',
		data(){
			return {
				form: undefined,
				isOver: false,
				style: "",
				//validMimeTypes: {'image/jpeg' : ['jpg', 'jpeg']},
				//files: []
				
			}
		},

		props: [
			//'uploadAudioTaskAnswerImage',
			'showUploadList',
			'payload',
			'audioFile',
			'upload',
			'changeName',
			'replaceMethod',
			'removeMethod',
			'validateMethod',
			'cancelMethod',
			'setValid',
			'edit',
			'cancelIsBeingReplacedMethod',
			'instructionText',
			'buttonText',
			'maxFiles',
			'validateNumOfFiles'
		],

		created()
		{
			/*window.vm.$on('uploadProgress',  () => {
				console.log("onuploadprogress")
				this.$forceUpdate();
			})*/

			this.$nextTick(() => {
				//e.preventDefault()
				this.$refs.uploadForm.addEventListener('click', (e) => {
					let tag = e.target.tagName;
					//console.log("######## tag", tag)
					if(tag.toLowerCase() === 'button'){
						e.preventDefault();
						document.querySelector('#file').click();
					}

				})

				this.$refs.uploadForm.addEventListener('submit', (e) => {
					e.preventDefault();
				})
			})


		},

		updated()
		{
			this.$nextTick(() => {

				if(typeof this.validateMethod !== 'undefined')
				{
					this.$store.dispatch(this.validateMethod)
					.then((valid) => {
						//console.log("valid", valid)
						if(typeof this.setValid === 'undefined'){
							this.$store.commit('checkpointsValidator/setValid', valid)
						} else {
							//console.log("hpe")
							this.$store.commit(this.setValid,valid)
						}
					})
				} else {
					console.error('validatorMissing')
				}
			})
		},

		mounted()
		{



			this.$nextTick(() => {
				
				//if(typeof this.$refs.uploadForm !== 'undefined'){
					this.form = this.$refs.uploadForm;
					this.form.addEventListener('drag', (e) => {
						
						e.preventDefault();
						e.stopPropagation();
						

						
					})

					this.form.addEventListener('drop', (e) => {
						
						e.preventDefault();
						e.stopPropagation();


						let files = e.dataTransfer.files;

						if(typeof this.maxFiles !== 'undefined') {



							if(typeof this.validateNumOfFiles === 'undefined')
							{

								if((files.length + this.filesToUpload.length) > this.maxFiles){
									this.style = {'background-color': 'red'};
									window.setTimeout(() => {
										this.style = "";
									}, 1000)
									return;
								}
							} else {
								let hasOne = true;
								this.validateNumOfFiles(files, (valid) => {

									hasOne = valid;
								})

								if(!hasOne)
								{
									this.style = {'background-color': 'red'};
									window.setTimeout(() => {
										this.style = "";
									}, 1000);
									return;
								}

							}

						}
						//this.$store.dispatch(this.method, files[0])
						this.style = "";
						//if(this.uploadAudioTaskAnswerImage !== true)
						//{

							let payload = files;
							if(typeof this.payload !== 'undefined')
							{
								payload = {
									files,
									...this.payload
								}
							}

							if(typeof this.upload === 'undefined')
							{
								this.$store.dispatch('files/upload', payload)
							} else {
								this.$store.dispatch(
									this.upload, payload
								)
							}

							
						/*} else if(this.uploadAudioTaskAnswerImage === true)
						/*{
							
							
							this.$store.dispatch('files/uploadAudioTaskAnswerImage', {audio: this.audioFile, image: files[0], changeName: this.changeName})
						} */



					}) // here ends the drop event handler



					

					this.form.addEventListener('dragenter', (e) => {

						e.preventDefault();
						e.stopPropagation();

						if(this.style === "")
						{
							this.style = {'background-color': '#5cb85c'};
						} 
						
					})

					this.form.addEventListener('dragover', (e) => {
						e.preventDefault();
						e.stopPropagation();
						//console.log('dragover', e.dataTransfer.files)
						if(this.style === "")
						{
							this.style = {'background-color': '#5cb85c'};
						}
					})


					this.form.addEventListener('dragleave', (e) => {
						e.preventDefault();
						e.stopPropagation();
						this.style = "" 
						
					})
				//}


			})
		},

		methods: {

			cancelIsBeingReplaced(name)
			{

				if(typeof this.cancelIsBeingReplacedMethod === 'undefined'){
					this.$store.dispatch('checkpoints/setIsBeingReplaced', {name: name, value: false});
				} else {

					this.$store.dispatch(this.cancelIsBeingReplacedMethod, {name: name, value: false})
				}
			},

			cancel(f)
			{

				if(typeof this.cancelMethod === 'undefined'){
					this.$store.dispatch('files/cancelReplace', f)
				} else {
					this.$store.dispatch(this.cancelMethod, f)
				}
			},

			replace(f)
			{

				if(typeof this.replaceMethod === 'undefined'){
					this.$store.dispatch('files/replace', f)
				} else {
					this.$store.dispatch(this.replaceMethod, f)
				}
			},

			remove(f)
			{

				if(typeof this.removeMethod === 'undefined'){
					
					this.$store.dispatch('files/remove', f)
				} else {

					this.$store.dispatch(this.removeMethod, f)
				}
			}
			
		},

		computed: {
			translater: {
				get()
				{
					return this.$store.getters['translate/translater'];
				}
			},

			isUploading: {
				get()
				{
					return this.$store.getters['files/isUploading']
				},

				set(value)
				{
					this.$store.commit('files/setIsUploading', value)
				}
			},

			filesToUpload: {
				get()
				{
					return this.$store.getters['files/filesToUpload'];
				}

				
			},

			audioTaskAnswerImagesToUpload: {
				get()
				{
					let ataitu = this.$store.getters['files/audioTaskAnswerImagesToUpload']
					//console.log("audioTaskAnswerImagesToUpload::get", ataitu)
					return ataitu;
				}
			}



			


	
		}
	}
		

</script>